import { createReducer } from 'redux-starter-kit';
import * as actions from './actions';
import { defaultMapState } from '../config';

// trees

const treesReducer = createReducer({}, {
  [actions.fetchTreesSuccess]: (state, action) => action.payload.trees,
});

const treesLoadingReducer = createReducer(false, {
  [actions.setTreesLoading]: (state, action) => action.payload.loading,
});

const treesLoadedReducer = createReducer(false, {
  [actions.setTreesLoaded]: (state, action) => action.payload.loaded,
});

const selectedTreeReducer = createReducer(null, {
  [actions.setSelecetedTree]: (state, action) => action.payload.treeKey,
});

const treesVisibleReducer = createReducer(false, {
  [actions.setTreesVisible]: (state, action) => action.payload.visible,
});

const treeSearchVisibleReducer = createReducer(false, {
  [actions.setTreeSearchVisible]: (state, action) => action.payload.visible,
});

// map

const mapViewportReducer = createReducer(defaultMapState, {
  [actions.setMapViewport]: (state, action) => ({ ...state, ...action.payload }),
  [actions.setMapZoom]: (state, action) => ({ ...state, ...action.payload }),
  [actions.setMapCenter]: (state, action) => ({ ...state, ...action.payload }),
  [actions.resetMap]: (state, action) => defaultMapState,
});

// root reducer

const rootReducer = {
  trees: treesReducer,
  treesLoading: treesLoadingReducer,
  treesLoaded: treesLoadedReducer,
  selectedTree: selectedTreeReducer,
  treesVisible: treesVisibleReducer,
  treeSearchVisible: treeSearchVisibleReducer,
  mapViewport: mapViewportReducer,
};

export default rootReducer;
